import { logError } from 'lib/logging'
import { useCallback, useState } from 'react'

export const useAudioUpload = (locationId: string) => {
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState<string | undefined>()

  const upload = useCallback(
    async (file: File): Promise<string | undefined> => {
      setUploading(true)
      setError(undefined)

      try {
        const formData = new FormData()
        formData.append(`file`, file)
        formData.append(`locationId`, locationId)

        const response = await fetch(`/api/dni/audio`, {
          method: `POST`,
          credentials: `include`,
          body: formData,
        })

        const json = await response.json()

        if (!response.ok) {
          setError(json.error || `Upload failed`)
          logError(`ivr-audio-upload`, `upload failed`, {
            locationId,
            fileName: file.name,
            status: response.status,
            error: json.error,
          })
          return undefined
        }

        return json.key
      } catch (err) {
        const message = err instanceof Error ? err.message : `Upload failed`
        setError(message)
        logError(`ivr-audio-upload`, `upload error`, { locationId, fileName: file.name, error: message })
        return undefined
      } finally {
        setUploading(false)
      }
    },
    [locationId],
  )

  const reset = useCallback(() => {
    setError(undefined)
  }, [])

  return { upload, uploading, error, reset }
}
